import { useContext } from "react";

import { css } from "@emotion/react";

import Menu, {
    centeredAnchorOrigin,
    centeredTransformOrigin
} from "components/DesignComponents/Menu";
import { COMPANY_SELECTOR_MENU } from "components/TutorialMode/constants";
import TutorialContext from "context/tutorial/tutorialContext";

import CompanyFilterContent from "./CompanyFilterContent";
import { CompanyFilterContext } from "./CompanyFilterState";

const FilterDesktop = () => {
    const { isTutorialActive, setTutorialOpen } = useContext(TutorialContext);
    const { anchorEl, closeMenu } = useContext(CompanyFilterContext);

    return (
        <Menu
            disableEscapeKeyDown={isTutorialActive}
            open={Boolean(anchorEl)}
            onClose={closeMenu}
            anchorEl={anchorEl}
            anchorOrigin={centeredAnchorOrigin}
            transformOrigin={centeredTransformOrigin}
            slotProps={{
                paper: {
                    id: COMPANY_SELECTOR_MENU
                },
                transition: {
                    onEntered: () => isTutorialActive && setTutorialOpen(true)
                }
            }}
            css={css({
                "& .MuiMenu-paper": {
                    width: "564px"
                }
            })}
        >
            <li>
                <CompanyFilterContent close={closeMenu} />
            </li>
        </Menu>
    );
};

export default FilterDesktop;
